import { useState } from 'react';
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import GlobalLoader from 'src/components/SuspenseLoader/GlobalLoader';
import { Button } from '@mui/material';
import moment from 'moment';
import { imgUrl } from 'src/Helpers/utils/Constant';
import dayjs from 'dayjs';

type IProps = {
  getDownloadData: () => Promise<any[]>;
  excelName: string;
};

const FeeWiseExcelGenerator = ({ getDownloadData, excelName }: IProps) => {
  const [loading, setLoading] = useState(false);

  const saveExcel = async () => {
    setLoading(true);
    try {
      const excelData = await getDownloadData();
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet(`${excelName}`);

      const excelTableHead = [
        'SL',
        'Date',
        'Voucher No',
        'Member ID',
        'Photo',
        'Company Name',
        'Owner name, Designation',
        'Validity',
        'Phone',
        'Zone',
        'Item Amount',
        'Total Amount',
        'Due Amount',
      ];

      const titleRow = worksheet.addRow(excelTableHead);
      worksheet.columns = Array.from(
        { length: excelTableHead.length },
        (_, index) => ({ width: index === 0 ? 15 : 30 }),
      );

      titleRow.eachCell((cell) => {
        cell.font = { bold: true };
      });

      for (let i = 0; i < excelData.length; i++) {
        const sData = excelData[i];
        const rowData = [
          i + 1,
          sData?.voucher_date
            ? moment(sData?.voucher_date).format('DD-MM-YYYY')
            : '',
          sData?.voucher_no || '',
          sData?.user_member_id_card_number || '',
          '', // Photo placeholder
          sData?.user_member_company_name || '',
          `${sData?.company_owner_name || ''}, ${
            sData?.company_owner_designation || ''
          }`,
          sData?.expiry_date ? dayjs(sData?.expiry_date).format('YYYY') : '',
          sData?.phone || '',
          sData?.user_member_zone_name || '',
          sData?.item_amount || '0.00',
          sData?.total_amount || '0.00',
          sData?.total_due || '0.00',
        ];

        const row = worksheet.addRow(rowData);
        row.height = 60; // Set row height for image
        row.alignment = { vertical: 'middle', horizontal: 'left' };

        if (sData?.company_owner_photo) {
          try {
            const response = await fetch(
              `${imgUrl}/${sData.company_owner_photo}`,
            );
            const blob = await response.blob();
            const arrayBuffer = await blob.arrayBuffer();

            const extension =
              sData.company_owner_photo.split('.').pop() || 'jpeg';
            const imageId = workbook.addImage({
              buffer: arrayBuffer,
              extension: (extension === 'jpg' ? 'jpeg' : extension) as any,
            });

            worksheet.addImage(imageId, {
              tl: { col: 4, row: i + 1 }, // i + 1 because tl.row is 0-indexed and header is row 0
              ext: { width: 70, height: 70 },
            });
          } catch (error) {
            console.error('Error adding image to excel:', error);
          }
        }
      }

      const excelDataGenerate = await workbook.xlsx.writeBuffer();
      const blob = new Blob([excelDataGenerate], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${excelName}.xlsx`);
    } catch (error: any) {
      console.error('Something Went Wrong', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? (
        <GlobalLoader />
      ) : (
        <Button onClick={saveExcel} variant='outlined' size='small'>
          Download Excel
        </Button>
      )}
    </div>
  );
};

export default FeeWiseExcelGenerator;
